import { render, staticRenderFns } from "./shiwuzhaoling.vue?vue&type=template&id=f3b5f202&scoped=true&"
import script from "./shiwuzhaoling.vue?vue&type=script&lang=js&"
export * from "./shiwuzhaoling.vue?vue&type=script&lang=js&"
import style0 from "./shiwuzhaoling.vue?vue&type=style&index=0&id=f3b5f202&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b5f202",
  null
  
)

export default component.exports